export default __webpack_public_path__ + "static/media/taxservice-header.bd242b61.jpg";